import React from "react";
import { Box, Button, Modal, SpaceBetween } from "@amzn/awsui-components-react";
import { renderVersionCollisionMessageOS } from "./version-utils-os";
import { VersionConfirmationModalOSProps } from "./definitions";

const VersionConfirmationModalOS: React.FC<VersionConfirmationModalOSProps> = ({
  visible,
  setVisible,
  collisions,
  onConfirm,
}) => {
  const handleConfirm = () => {
    onConfirm();
    setVisible(false);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  return (
    <Modal
      visible={visible}
      onDismiss={handleCancel}
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="link" onClick={handleCancel}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleConfirm}>
              Confirm
            </Button>
          </SpaceBetween>
        </Box>
      }
      header="Confirm version creation"
    >
      <SpaceBetween direction="vertical" size="m">
        {renderVersionCollisionMessageOS(collisions)}
      </SpaceBetween>
    </Modal>
  );
};

export default VersionConfirmationModalOS;
